<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import LoadingSpin from '~common/loading-spin.vue'
import BaseButton from '~common/base-button.vue'
import { useInstruction } from '~composables/promotion/use-promotion-static'
import { useUserData } from '~/composables/account/use-user-data'
import { AccountTabs } from '~/constants/account'
import { PROMOTION_PLAN_TYPE, PROMOTION_SLUG_BY_TYPE } from '~/constants'

const {
  promotionBanners,
  currentIndex,
  promotionDetail,
  availablePromotionsDetail,
  loading,
  getPromotion,
  fetchPromotionDetail
} = useInstruction()

const { currentUser } = useUserData()
const packageId = computed(() => {
  return currentUser.value?.package_id
})
const route = useRoute()

const isButtonDisabled = computed(() => {
  const isWelcomePromotionUsed =
    availablePromotionsDetail.value === PROMOTION_PLAN_TYPE.WELCOME &&
    (packageId.value === PROMOTION_PLAN_TYPE.WELCOME ||
      packageId.value === PROMOTION_PLAN_TYPE.COMMISSION ||
      packageId.value === PROMOTION_PLAN_TYPE.FIRST_50)

  const isFifrtyPercentagePromotionUsed =
    availablePromotionsDetail.value === PROMOTION_PLAN_TYPE.FIRST_50 && packageId.value === PROMOTION_PLAN_TYPE.FIRST_50

  return (
    (availablePromotionsDetail.value === PROMOTION_PLAN_TYPE.WELCOME &&
      availablePromotionsDetail.value === PROMOTION_PLAN_TYPE.FIRST_50) ||
    isWelcomePromotionUsed ||
    isFifrtyPercentagePromotionUsed
  )
})

if (!route.query.tab) {
  await fetchPromotionDetail(promotionBanners.value[0].slug)
}
</script>
<template>
  <div class="promotion">
    <div class="container">
      <div class="promotion__breadcrumb">
        <span class="icon-news-home"></span>
        <NuxtLink to="/">Trang chủ</NuxtLink>
        <span class="icon-chevron-right"></span>
        <NuxtLink class="current-slug">Khuyến mãi</NuxtLink>
      </div>

      <div class="d-flex align-items-start gap-4">
        <div>
          <NuxtLink
            v-for="(item, index) in promotionBanners" :key="index"
            :to="`${AccountTabs.PROMOTION}?tab=${item.slug}`"
            :class="['promotion__sidebar--item', { active: index === currentIndex }, item.packageName]"
          >
            <img
              v-if="index === currentIndex"
              src="/assets/images/pages/promotion/promotion-tick-badge.png"
              class="promotion__sidebar--tick"
              alt="tick badge"
            />
            <img :src="item.thumbnailUrl" class="promotion__sidebar--item--banner" :alt="item.title" />
            <ClientOnly>
              <span v-if="item.packageId === packageId && packageId !== availablePromotionsDetail" class="used-text">
                Đã sử dụng
              </span>
            </ClientOnly>
            <div class="promotion__sidebar--content">
              <div v-if="item.badgeTitle" class="promotion__sidebar--badgeTitle">
                <span>{{ item.badgeTitle }}</span>
              </div>
              <div class="promotion__sidebar--title">{{ item.title }}</div>
              <div class="promotion__sidebar--subtitle">{{ item.subTitle }}</div>
            </div>
          </NuxtLink>
        </div>

        <div class="promotion__content">
          <div v-if="promotionBanners[currentIndex].packageName === PROMOTION_SLUG_BY_TYPE.DUA_TOP_THE_THAO">
            <h1 class="promotion__content__title">ĐUA TOP TÀI PHÚ - NHẬN QUÀ TIỀN TỈ</h1>
            <a class="promotion__content__event-link" @click="getPromotion()">
              <span></span>Xem danh sách xếp hạng
            </a>
          </div>

          <LoadingSpin v-if="loading" />
          <template v-else>
            <div v-if="promotionDetail" class="promotion__content--txt scrollbar" v-html="promotionDetail"></div>

            <div class="promotion__footer">
              <div class="promotion__footer--text">
                {{ promotionBanners[currentIndex].footer.text }} {{ promotionBanners[currentIndex].footer.highlight }}
              </div>
              <ClientOnly>
                <BaseButton :disable="isButtonDisabled" :isFullWidth="false" class="m-0" @click="getPromotion">
                  {{ promotionBanners[currentIndex]?.footer.button?.text ?? 'Nhận khuyến mãi'}}
                </BaseButton>
              </ClientOnly>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/promotion/index.scss';
</style>
